import { get } from '../base';

import { DateTimeFormatsResponse } from './types-get-date-time-formats';

export function getDateTimeFormats(): Promise<DateTimeFormatsResponse> {
  return get('v5/dateTimeFormats').json();
}
